import { Node } from 'hubspot-prosemirror/pm/model';
import { Decoration, EditorView } from 'hubspot-prosemirror/pm/view';
import { TGetPos, ViewConfigType, EditorConfigType } from '../../types';
import { createReactNodeView } from './ReactNodeView';

export function buildNodeViewsFromConfig(
  viewConfig: ViewConfigType,
  handleCreatePortal: (portal: any) => void,
  editorConfig?: EditorConfigType
) {
  const views: any = {};
  for (const key in viewConfig) {
    if (key) {
      views[key] = (
        node: Node,
        view: EditorView,
        getPos: TGetPos,
        decorations: Decoration[]
      ) => {
        const { component, updateFn } = viewConfig[key];
        return createReactNodeView({
          node,
          view,
          getPos,
          decorations,
          component,
          updateFn,
          onCreatePortal: handleCreatePortal,
          editorConfig,
        });
      };
    }
  }
  return views;
}
